'use client'
import react, { useEffect } from 'react'
import axios from 'axios';
import createAuthRefreshInterceptor from "axios-auth-refresh";

import { CMM } from 'Lib/Cmm';
import { authStore } from 'store/authStore';
/**
 * json param -> uri querystring 변환 
 */
const getQueryString = (params = {}) => {
  const qs = [];
  for (const key in params) {
    qs.push(`${key}=${params[key]}`);
  }
  return qs.join('&');
}

/**
 * Axios 헤더에 토큰 지정
 */
export const setAxiosAuth = () => {
  //console.log('setAxiosAuth::',accToken);
  axios.defaults.headers.common['Authorization'] = `Bearer ${authStore.accToken}`;
}
/**
 * Axios 헤더값 토큰값 확인 
 */
export const getAxiosAuth = () => {
  //console.log('axios header::',axios.defaults.headers.common['Authorization']);
}

/**
 * 토큰 재발행 
 */
const refreshFetcher = failedRequest => {
  //const [refToken, setRefToken] = useState('');
  //let resultVal='aaa' ;
  console.log('useFatch에서 authStore 값 확인 :::::', authStore.refToken);


  // useEffect(() => {
  //   localStorage.setItem('test','1111');
  //   console.log('useEffect::', localStorage.getItem('test'));
  //   console.log(navigator.userAgent)
  // }, [])

  return axios
    .post(`${CMM.SERVER_URL_AUTH}/oauth/token`, {
      refresh_token: authStore.refToken,
      client_secret: 'd3576ef400c8440284ef72642f806914',
      client_id: 'chatbot.co.kr',
      grant_type: 'refresh_token'
    })
    .then(response => {
      console.log('refreshFetch::::', response.data)
      sessionStorage.setItem('@userInfo', {
        accToken: response.data.access_token,
        refToken: response.data.refresh_token
      });
      //AsyncStorage.setItem('@token', refresh_token.data.token);
      failedRequest.response.config.headers['Authorization'] = 'Bearer ' + response.data.access_token;
      return Promise.resolve();
    })
    .catch((e) => {
      //router.replace('/login');
      console.log('error!!', e);
      //강제 로그아웃()
      authStore.delToken();
    });
};

createAuthRefreshInterceptor(axios, refreshFetcher);

/**
 * FETCHING (SWR)
 */
export const fetcher = (url) => {

  // console.log('fetcher:::', authStore.accToken);
  return axios
    .get(url, {
      headers: {
        'Authorization': `Bearer ${authStore.accToken}`,
      }
    })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
};

/**
 * FETCHING (POST)
 */
export const postAxios = (url, param) => {
  // console.log('fetcher:::', authStore.accToken);
  //if (!authStore.accToken) return;
  return axios
    .post(url, param, {
      headers: {
        'Authorization': `Bearer ${authStore.accToken}`
      }
    })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
};

/**
 * FETCHING (POST) catalog 등록
 */
export const postCatalog = (url, param, titleImage, files = []) => {
  //console.log('fetcher:::', authStore.accToken);
  //if (!authStore.accToken) return;

  //console.log('postCatalog:::', param.c_idx, files);
  const formData = new FormData();

  for (let key in param) {
    //console.log('for key::::::::', key,  param[key])
    formData.append(key, param[key]);
  }

  // param.map((item, index) => {
  //   console.log(item);
  //   //formData.append()
  // });

  //console.log('postCatalog titleImage::::', titleImage)
  //title image
  // formData.append('fileup',{
  //   uri: titleImage.uri,
  //   type: 'image/jpeg',
  //   name: titleImage.name,
  // })
  //title image

  if (typeof (titleImage.uri) != 'string') {
    formData.append('fileup', titleImage.uri, titleImage.name)
  }


  files?.map((item, index) => {
    console.log('files.map::::::::', item);
    if (item.ctype.includes('image') && item.gbn == 'A') {
      formData.append('fileup', item.uri, item.filenm)
    } else if (item.ctype.includes('video') && item.gbn == 'A') {
      formData.append('fileup', item.uri, item.filenm)
      // formData.append('fileup',{
      //   uri: item.uri, 
      //   type: 'application/octet-stream',
      //   name: item.filenm,
      // });

    }

  })

  //console.log('formData', formData, formData.fileup);
  //return 'ERROR';

  //if (Platform.OS === 'ios') {

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`

    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });

};


/**
 * FETCHING (POST) 한개 파일 등록
 */
export const postWithFile = (url, param, files = []) => {
  // console.log('postWithFile:::', param, files);

  //console.log('postCatalog:::', param, files);
  const formData = new FormData();

  for (let key in param) {
    // console.log('for key::::::::', key, param[key])
    formData.append(key, param[key]);
  }

  //files.map((item, index) => {
  // console.log('files:::::::', (Object.keys(files).length === 0) ? '111' : '222', files);

  files?.map((item, index) => {
    // console.log('files item::', item);
    formData.append('fileup', item.uri, item.filenm)
  })

  //console.log('formData', formData, formData.fileup);
  //return;

  //if (Platform.OS === 'ios') {

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`
    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
};

/**
 * FETCHING (POST) 여러 파일 등록
 */
export const postWithFiles = (url, param, files = []) => {
  console.log('postBanner:::', param, files);

  //console.log('postCatalog:::', param, files);
  const formData = new FormData();

  for (let key in param) {
    console.log('for key::::::::', key, param[key])
    formData.append(key, param[key]);
  }


  files?.map((item, index) => {
    console.log('files.map::::::::', item);
    formData.append('fileup', item.uri, item.filenm)

  })

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`
    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
};
/**
 * FETCHING (POST) board 등록
 */
export const postBoard = (url, param, files = []) => {
  //console.log('fetcher:::', authStore.accToken);
  //if (!authStore.accToken) return;

  //console.log('postCatalog:::', param.c_idx, files);
  const formData = new FormData();

  for (let key in param) {
    //console.log('for key::::::::', key,  param[key])
    formData.append(key, param[key]);
  }


  console.log('files::::::::', files);

  files?.map((item, index) => {
    console.log('files.map::::::::', item);
    if (item.gbn == 'A') {
      formData.append('fileup', item.uri, item.filenm)

    }

  })

  //console.log('formData', formData, formData.fileup);
  //return 'ERROR';

  //if (Platform.OS === 'ios') {

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`

    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });

};

/**
 * FETCHING (POST) 
 */
export const postProfile = (url, param, files = {}) => {
  console.log('postProfile:::', param, files);
  //if (!authStore.accToken) return;

  //console.log('postCatalog:::', param, files);
  const formData = new FormData();

  for (let key in param) {
    console.log('for key::::::::', key, param[key])
    formData.append(key, param[key]);
  }

  //files.map((item, index) => {
  //console.log('files:::::::',(Object.keys(files).length === 0)?'111':'222', files);

  if (Object.keys(files).length > 0) {
    console.log('FILES::::', files.uri, files.name)
    formData.append('fileup', files.uri, files.name)
  }
  // formData.append('fileup',{
  //   uri: files.uri, 
  //   type: 'application/octet-stream',
  //   name: files.name
  // });

  //})

  //console.log('formData', formData, formData.fileup);
  //return;

  //if (Platform.OS === 'ios') {

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`
    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
};

/**
 * FETCHING (POST) 채팅 이미지 등록
 */
export const postChatImage = (url, param, files = []) => {
  //console.log('fetcher:::', authStore.accToken);
  //if (!authStore.accToken) return;

  //console.log('postCatalog:::', param.cr_idx, files);
  const formData = new FormData();

  for (let key in param) {
    //console.log('for key::::::::', key,  param[key])
    formData.append(key, param[key]);
  }

  //files.map((item, index) => {
  //  console.log('files.map::::::::',item.uri, item.ctype);

  formData.append('fileup', files.uri, files.name)
  // formData.append('fileup',{
  //   uri: files.uri, 
  //   type: 'application/octet-stream',
  //   name: files.name
  // });

  //})

  //console.log('formData', formData, formData.fileup);
  //return;

  //if (Platform.OS === 'ios') {

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`
    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
  // } else {
  //   return fetch(url, {
  //     method: 'POST',
  //     headers: { 
  //       'Accept': 'application/json',
  //       'Content-Type': 'multipart/form-data',
  //       'Authorization': `Bearer ${authStore.accToken}`
  //     },
  //     body: formData,
  //   })
  //   .then((response) => response.json())
  //   .then((response) => {
  //     console.log('upload Result::', response);
  //     return response.message;
  //   })
  //   .catch((e) => {
  //     console.log('upload Error::', e);
  //     return 'ERROR';
  //   })
  // }
};


/**
 * FETCHING (POST) PDF 전송
 */
export const postPdf = (url, param, files = []) => {
  //console.log('fetcher:::', authStore.accToken);
  //if (!authStore.accToken) return;

  //console.log('postCatalog:::', param.cr_idx, files);
  const formData = new FormData();


  //files.map((item, index) => {
  //  console.log('files.map::::::::',item.uri, item.ctype);

  formData.append('fileup', files.uri, files.name)
  // formData.append('fileup',{
  //   uri: files.uri, 
  //   type: 'application/octet-stream',
  //   name: files.name
  // });

  //})

  //console.log('formData', formData, formData.fileup);
  //return;

  //if (Platform.OS === 'ios') {

  return axios({
    url: url,
    method: 'POST',
    data: formData,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${authStore.accToken}`
    },
    transformRequest: (data, error) => {
      return formData;
    },
  })
    .then((response) => {
      return response.data.message;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
  // } else {
  //   return fetch(url, {
  //     method: 'POST',
  //     headers: { 
  //       'Accept': 'application/json',
  //       'Content-Type': 'multipart/form-data',
  //       'Authorization': `Bearer ${authStore.accToken}`
  //     },
  //     body: formData,
  //   })
  //   .then((response) => response.json())
  //   .then((response) => {
  //     console.log('upload Result::', response);
  //     return response.message;
  //   })
  //   .catch((e) => {
  //     console.log('upload Error::', e);
  //     return 'ERROR';
  //   })
  // }
};



/**
 * FETCHING (POST No Auth)
 */
export const postNoauth = (url, param) => {
  return axios
    .post(url, param)
    .then((response) => {
      return response.data;
    })
    .catch((e) => {
      console.log('error', e);
      return 'ERROR';
    });
};

/**
 * 다시 불러오기
 */
// export const prefetch = (url, params = {}) => {
//   const uri = `${url}?${getQueryString(params)}`;
//   return mutate(uri, fetcher(uri));
// };

/**
 * (axios 불러오기)
 */
export const fetchAxios = (url, params = {}) => {
  //console.log('useFetch:::::::',url, params)
  return fetcher(`${url}?${getQueryString(params)}`);
}


/**
 * NO SWR
 */
// export const fetch_noSWR = (url, params = {}) => {
//   //console.log('noswr:::', params);
//   return fetcher(`${url}?${getQueryString(params)}`);
// }

